'use client';

import { useEffect } from 'react';

export type ClientGTMScriptProps = {
  script: string;
};

export const ClientGTMScript = ({ script }: ClientGTMScriptProps) => {
  useEffect(() => {
    const gtmScript = document.createElement('script');
    gtmScript.setAttribute('type', 'text/javascript');
    gtmScript.dataset.testid = 'gtm';
    gtmScript.text = script;
    document.body.insertBefore(gtmScript, document.body.firstChild);
  }, [script]);
  return null;
};
